import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center">
      <div className="tactical-card p-10" data-testid="payment-cancel">
        <XCircle className="w-16 h-16 text-amber-400 mx-auto" />
        <h1 className="font-display text-2xl font-bold text-white mt-6">Payment Cancelled</h1>
        <p className="text-slate-400 mt-2">Your payment was cancelled and you have not been charged. {params.get("order") && <span className="font-mono text-cyan-400">{params.get("order")}</span>}</p>
        <Link to="/products" className="mt-8 inline-flex items-center justify-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] btn-glow text-white font-semibold px-6 py-3.5 rounded-full">
          Back to Catalog
        </Link>
      </div>
    </div>
  );
}
